export default "__VITE_ASSET__M5cXm_MW__"